import React, { useRef, useEffect } from 'react';
import { createPortal } from 'react-dom';
import cx from 'classnames';
import useForceUpdate from 'use-force-update';
import './style/WaterMark.css.json';
const WaterMarkView = (props) => {
    const boxRef = useRef(null);
    const markerRef = useRef(null);
    const markersRef = useRef(null);
    const renderCanvas = (text) => {
        if (!markerRef.current || !boxRef.current || !markersRef.current) {
            return;
        }
        const marker = markerRef.current;
        const markers = markersRef.current;
        const box = boxRef.current;
        const ctx = marker.getContext('2d');
        if (!ctx) {
            return;
        }
        ctx.clearRect(0, 0, marker.width, marker.height);
        ctx.font = '20px 黑体';
        ctx.rotate((-20 * Math.PI) / 180);
        ctx.fillStyle = 'rgba(100,100,100,0.05)';
        ctx.fillText(text, -20, 80);
        ctx.rotate((20 * Math.PI) / 180);
        const ctxr = markers.getContext('2d');
        if (!ctxr) {
            return;
        }
        ctxr.clearRect(0, 0, markers.width, markers.height);
        const pat = ctxr.createPattern(marker, 'repeat');
        if (!pat) {
            return;
        }
        ctxr.fillStyle = pat;
        ctxr.fillRect(0, 0, markers.width, markers.height);
        const backgroundImg = markers.toDataURL();
        const style = {
            display: 'block',
            backgroundImage: `url(${backgroundImg})`,
            position: 'fixed',
            width: '100vw',
            height: '100vh',
            zIndex: 1001,
            pointerEvents: 'none',
            top: '0px',
            left: '0px',
        };
        Object.assign(box.style, style);
    };
    useEffect(() => {
        renderCanvas(props.text);
    });
    return (React.createElement("div", { id: "WATERMARKER", className: cx(props.className), ref: boxRef },
        React.createElement("canvas", { style: { display: 'none' }, width: "100px", height: "100px", ref: markerRef }),
        React.createElement("canvas", { style: { display: 'none' }, width: "1000px", height: "1000px", ref: markersRef })));
};
const $container = document.querySelector('body');
let observer;
const WaterMark = (props) => {
    const forceUpdate = useForceUpdate();
    useEffect(() => {
        setTimeout(() => {
            const $watermarker = document.getElementById('WATERMARKER');
            observer = new MutationObserver(mutationsList => {
                let ele;
                for (ele of mutationsList) {
                    if (ele.removedNodes[0] && ele.removedNodes[0].isEqualNode($watermarker)) {
                        if (!$container || !$watermarker) {
                            return;
                        }
                        $container.appendChild($watermarker);
                        return true;
                    }
                    if (ele.target && ele.target.isEqualNode($watermarker)) {
                        forceUpdate();
                        return true;
                    }
                    return false;
                }
                return false;
            });
            if (!$container) {
                return;
            }
            observer.observe($container, { attributes: true, childList: true, subtree: true });
        }, 1000);
        return () => {
            observer.disconnect();
        };
    }, []);
    return ($container &&
        createPortal(React.createElement(WaterMarkView, { text: props.text, className: props.className }), $container));
};
export default WaterMark;
